/**
 * Simple detection of screen orientation, as defined by w3c css3-mediaqueries
 * @return {string}         Returns 'portrait' or 'landscape'
 */
define('screen-orientation/screen-orientation',['require','exports','module'],function(require,exports,module){

	var	clientNode,
		clientPre,
		clientWidth,
		clientHeight,
		PORTRAIT='portrait',
		LANDSCAPE='landscape';

	if('innerHeight' in window){
		clientNode=window;
		clientPre='inner';
	}else{
		clientNode=document.documentElement;
		clientPre='client';
	}
	clientWidth=clientPre+'Width';
	clientHeight=clientPre+'Height';

	return function(){
		return clientNode[clientHeight] >= clientNode[clientWidth] ? PORTRAIT : LANDSCAPE;
	}
});
